import { render, staticRenderFns } from "./PreviewPostContentField.vue?vue&type=template&id=06bb48b6&scoped=true&"
import script from "./PreviewPostContentField.vue?vue&type=script&lang=js&"
export * from "./PreviewPostContentField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06bb48b6",
  null
  
)

export default component.exports